import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const skeletonVariants = cva(
  'animate-pulse bg-[var(--color-surface-hover)]',
  {
    variants: {
      variant: {
        text: 'h-4 w-full rounded',
        circular: 'rounded-full',
        rectangular: 'h-24 w-full rounded-lg',
      },
    },
    defaultVariants: {
      variant: 'text',
    },
  }
)

export interface SkeletonProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof skeletonVariants> {
  width?: string
  height?: string
}

const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, variant, width, height, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(skeletonVariants({ variant }), width, height, className)}
        {...props}
      />
    )
  }
)
Skeleton.displayName = 'Skeleton'

export { Skeleton, skeletonVariants }
